import styled from "styled-components"
import Link from "next/link"
import { useMemo, useCallback, useEffect } from "react"
import Text from "~/components/Text"
import { useRouter } from "next/router"
import StyledLink from '~/components/UI/Link'
import Icon from "../UI/Icon"
import HeaderItemLink from "./HeaderItemLink"

const MenuContainer = styled.div`
  right: 0;
  top: 50px;
  z-index:1000 !important;
  position: absolute;
  width: 200px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 10px 0 rgba(0, 85, 255, 0.24);
  background-color: #ffffff;
  display: none;
  opacity: 0;
  transition: 200ms;
`

const LinkItem = styled(StyledLink)`
  z-index:1000 !important;
  display: block;
  padding: 10px;
  background-color: #fff;
  transition: 200ms;
  font-weight: normal;
  :hover {
    background-color: #ebf3ff;
    cursor: pointer;
  }

  &.more-menu-item-active {
    z-index:1000 !important;
    background-color: #ebf3ff;
    font-weight: bold;
  }
`

const IconDropDown = styled(Icon)`
  color: #007bff;
`

interface Props {
  id: string
  title: string
  list: Array<{ text: string, link: string }>
}
const MoreMenu: React.FC<Props> = ({ id, title, list }) => {
  const router = useRouter()

  const menuItems = useMemo(() => {
    return list.map(item => {
      return (
        <Link key={item.link} href={item.link}>
          <LinkItem href={item.link} className={router.pathname === item.link ? 'more-menu-item-active' : ''} key={item.link}>
            <Text color='#000 !important'>
              {item.text}
            </Text>
          </LinkItem>
        </Link>
      )
    })
  }, [list, router])

  const handleOpenMenu = useCallback(() => {
    let timer: number
    const els = document.getElementsByClassName(id)
    const contentEl = document.getElementById(`${id}-content`)
    const onEnter = () => {
      if (contentEl) {
        clearTimeout(timer)
        contentEl.style.display = 'block'
        setTimeout(() => {
          contentEl.style.opacity = '1'
        }, 100);
      }
    }

    const onLeave = () => {
      timer = setTimeout(() => {
        requestAnimationFrame(() => {
          if (contentEl) {
            contentEl.style.opacity = '0'
            setTimeout(() => {
              contentEl.style.display = 'none'
            }, 100);

          }
        })
      }, 150);
    }

    if (els) {
      for (let i = 0; i < els.length; i++) {
        const el = els[i] as HTMLElement
        el.addEventListener('mouseenter', onEnter)
        el.addEventListener('mouseleave', onLeave)
      }
    }

    return () => {
      if (els) {
        for (let i = 0; i < els.length; i++) {
          const el = els[i] as HTMLElement
          el.removeEventListener('mouseenter', onEnter)
          el.removeEventListener('mouseleave', onLeave)
        }
      }
    }
  }, [])

  useEffect(() => {
    const removeListeners = handleOpenMenu()
    return removeListeners
  }, [])

  return (
    <>
      <HeaderItemLink className={id}>
        <Text>
          {title}
        </Text>
        <IconDropDown className='header-icon' style={{ marginLeft: 5 }} name='drop-down' />
      </HeaderItemLink>
      <MenuContainer className={id} id={`${id}-content`}>
        {menuItems}
        {/* <LinkItem href={ROUTES.BLOG} target='_blank'>
          <Text color='#000 !important'>
            {t`Blog`}
          </Text>
        </LinkItem>
        <LinkItem href={ROUTES.SUPPORT} target='_blank'>
          <Text color='#000 !important'>
            {t`Hỗ Trợ`}
          </Text>
        </LinkItem> */}
      </MenuContainer>
    </>
  )
}

export default MoreMenu
